import React, { useState, useEffect } from 'react';
import '../../components/style.css';
import loadingimg from "../../assets/images/loading.jpg.gif"

function CasteWiseReport() {
  const [classData, setClassData] = useState([]);
  const [casteData, setCasteData] = useState([]);
  const [udiseNumber, setUdiseNumber] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [divisionOptions, setDivisionOptions] = useState([]);
  
  const [selectedBoarder, setSelectedBoarder] = useState("");
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  const [loading, setLoading] = useState(true); // Loading state
  const [logoURL, setLogoURL] = useState(null);

  const [schoolData, setSchoolData] = useState(null);

  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);

  const classOrder = [
    language === 'English' ? 'Class I' : 'इयत्ता पहिली',
    language === 'English' ? 'Class II' : 'इयत्ता दुसरी',
    language === 'English' ? 'Class III' : 'इयत्ता तिसरी',
    language === 'English' ? 'Class IV' : 'इयत्ता चौथी',
    language === 'English' ? 'Class V' : 'इयत्ता पाचवी',
    language === 'English' ? 'Class VI' : 'इयत्ता सहावी',
    language === 'English' ? 'Class VII' : 'इयत्ता सातवी',
    language === 'English' ? 'Class VIII' : 'इयत्ता आठवी',
    language === 'English' ? 'Class IX' : 'इयत्ता नववी',
    language === 'English' ? 'Class X' : 'इयत्ता दहावी',
    language === 'English' ? 'Class XI' : 'इयत्ता अकरावी',
    language === 'English' ? 'Class XII' : 'इयत्ता बारावी'
  ];

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };
  const fetchClassDivData = async () => {
    try {
      const storedDivClasses = localStorage.getItem("classDiv");
      if (storedDivClasses) {
        const data = JSON.parse(storedDivClasses);
        
        const classList = [];
        const divisionSet = new Set(); // Use a Set to store unique divisions
  
        for (const [className, value] of Object.entries(data)) {
          if (value === true) {
            // Class without divisions
            classList.push(className);
          } else if (typeof value === 'object') {
            // Class with divisions
            classList.push(className);
            Object.keys(value).forEach(div => {
              if (value[div]) {
                divisionSet.add(div); // Add only true divisions to the Set
              }
            });
          }
        }
  
        setClassData(classList);
        setDivisionOptions(Array.from(divisionSet)); // Convert Set to Array and set the state
      }
    } catch (error) {
      console.error("Error fetching classDiv data: ", error);
    }
  };
    
      useEffect(() => {
        fetchClassDivData();
      }, [udiseNumber]);
  
  useEffect(() => {
    const fetchCasteCounts = async () => {
      if (udiseNumber) {
        setLoading(true);
        try {
          const db = await openIndexedDB();
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const allRecords = objectStore.getAll();
    
          allRecords.onsuccess = (event) => {
            const data = event.target.result;
            if (data) {
              const allCastes = {};
              data.forEach(student => {
                const isActive = student.isActive !== false; 
                console.log('Student:', student, 'isActive:', isActive);

                if (
                  student && 
                  student.caste && 
                  student.currentClass && 
                  student.gender && isActive &&
                  (selectedDivision === "" || student.division === selectedDivision)
                ) {
                  if (
                    (selectedBoarder === "true" && student.isHosteller) ||
                    (selectedBoarder === "false" && !student.isHosteller) ||
                    selectedBoarder === "" 
                  ) {
                    const caste = student.caste;
                    const classKey = student.currentClass.trim(); // Trim spaces
                    const genderKey = student.gender.toLowerCase();
    
                    if (!allCastes[caste]) {
                      allCastes[caste] = { name: caste, classes: {} };
                    }
    
                    if (!allCastes[caste].classes[classKey]) {
                      allCastes[caste].classes[classKey] = { male: 0, female: 0 };
                    }
    
                    allCastes[caste].classes[classKey][genderKey] += 1;
                  }
                }
              });
    
              const casteArray = Object.values(allCastes);
              setCasteData(casteArray);
            }
          };
    
          allRecords.onerror = (event) => {
            console.error('Error fetching student data from IndexedDB:', event.target.error);
          };
        } catch (error) {
          console.error('Error fetching caste data:', error);
        } finally {
          setLoading(false); // Set loading to false after fetching
        }
      }
    };
  
    fetchCasteCounts();
  }, [udiseNumber, selectedDivision, selectedBoarder]);
  

  const getClassTotal = (caste, className, gender) => {
    if (caste && caste.classes && caste.classes[className]) {
      return caste.classes[className][gender] || 0;
    } else {
      return 0;
    }
  };

  const getClassTotalOverall = (className, gender) => {
    return casteData.reduce((total, caste) => total + getClassTotal(caste, className, gender), 0);
  };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value);
  };

  const handlePrint = () => {
    const printContent = document.querySelector('.table-responsive'); // Adjust selector to match your layout
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true); // Clone the main content
  
      // Open a new window for printing
      const printWindow = window.open('', '', 'height=800,width=1000');
      printWindow.document.write(`
        <html>
          <head>
            <style>
              @page {
                size: A4 landscape;
                margin: 3mm;
                padding: 15px;
                border: 1px solid black;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
              table {
                border-collapse: collapse;
                width: 100%;
                font-size: 16px;
              }
              th, td {
                border: 1px solid black;
                text-align: center;
                padding: 5px;
              }
              td {
                font-size: 16px;
              }
              th {
                background-color: #82CAFA;
              }
              .print-button {
                display: none;
              }
              .school-header-container {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .school-header2 {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex: 0 0 auto; /* Prevent this section from growing */
                margin-right: 10px;
              }
              .school-header2 img {
                max-height: 70px;
              }
              .school-header {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center; margin-left:-70px;
                flex: 1 1 auto; /* This makes the school header take available space */
              }
              .school-header h1 {
                font-size: 28px;
                margin: 5px 0;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .school-header .report-title {
                font-size: 20px;
                margin: 5px auto;
                font-weight: bold;
                border: 1px solid black;
                width: 200px;
                padding: 5px;
                text-align: center;
                border-radius: 10px;
                background-color: black;
                color: white;
              }
              .school-header .report-tit {
                font-size: 16px;
                margin: 5px auto;
                font-weight: bold;
                text-align: center;
              }
            </style>
          </head>
            <body>
            <div class="school-header-container">
              <div class="school-header2">
                ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
              </div>
              <div class="school-header">
                <div style="margin-left: 15px;">
                  <h1>${schoolData ? schoolData.schoolName : " "}</h1>
                  <div class="report-tit">
                    ${language === 'English' ? 'Taluka' : 'तालुका'} ${schoolData ? schoolData.taluka : " "} , ${language === 'English' ? 'District' : 'जिल्हा'} : ${schoolData ? schoolData.jilha : " "}
                  </div>
                  <div class="report-title">
                    ${language === "English" ? "Caste Wise Report" : "जातनिहाय अहवाल"}
                  </div>
                </div>
              </div>
            </div>
            <style>
              .styled-table {
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              }
            </style>
            ${cloneContent.outerHTML}
          </body>
        </html>
`);
      printWindow.document.close();
      if (logoURL) {
        const img = printWindow.document.querySelector('.school-header2 img');
        img.onload = () => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        };
      } else {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }
    } else {
      console.error('Content to print not found');
    }
  };


  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo); // Set the logo URL
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
    fetchSchoolData ();
}, [udiseNumber]);



  return (
    <div>
      <div className='main-content-of-page'>
        <style>
          {`
            @media print {
              .table th,
              .table td {
                background-color: transparent !important;
                -webkit-print-color-adjust: exact;
              }
              .bg-secondary {
                background-color: transparent !important;
              }
              .print-button {
                display: none;
              }
              .custom-heading-text{
                margin: -5px auto;
              }
            }
          `}
        </style>
        <center style={{ borderBottom: '0.5px solid gray', padding: '-10px', marginBottom: '20px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
           
            <div className="custom-heading" style={{ paddingBottom: '-20px', marginTop: '-10px' }}>
              <h3 className="custom-heading-text text-center" style={{ color:'#03365e', fontWeight:'600'}}>
                {language === "English" ? "Caste Wise Report" : "जातनिहाय अहवाल"}
              </h3>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: '10px' ,paddingTop:'10px', borderTop:'1px solid gray'}}>

              <div className="dropdown-container" style={{ textAlign: 'center', marginRight: '20px', marginBottom: '10px' }}>
                <label htmlFor="division-select" style={{ marginRight: '10px' }}>
                  {language === "English" ? "Select Division" : "तुकडी निवडा"}:
                </label>
                <select
                  id="division-select"
                  value={selectedDivision}
                  onChange={handleDivisionChange}
                  className="form-control"
                  style={{ width: '200px', display: 'inline-block' }}
                >
                  <option value="">{language === "English" ? "Select Division" : "तुकडी निवडा"}</option>
                  {divisionOptions.map((division, index) => (
                    <option key={index} value={division}>{division}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </center>

        <div>
          <button onClick={handlePrint} className="print-button btn btn-primary" style={{ position: 'absolute', right: 20, top: 90 }}>Print</button>
        </div>
        <div className='table-responsive'>
          <table className="table mb-5 text-center">
            <thead>
              <tr>
                <th className='text-center'><b>{language === "English" ? "Caste" : "जात"}</b></th>
                {classData.map((className, index) => (
                  <React.Fragment key={index}>
                    <th className='text-center' colSpan={2}>{className}</th>
                  </React.Fragment>
                ))}
                <th className='text-center' colSpan={2}>{language === "English" ? "Total" : "एकूण"}</th>
                <th className='text-center'>{language === "English" ? "Sum" : "बेरीज"}</th>
              </tr>
              <tr>
                <th></th>
                {classData.map((_, index) => (
                  <React.Fragment key={index}>
                    <th className='text-center'>{language === "English" ? "Boy" : "मुलगा"}</th>
                    <th className='text-center'>{language === "English" ? "Girl" : "मुलगी"}</th>
                  </React.Fragment>
                ))}
                <th className='text-center'>{language === "English" ? "Boy" : "मुलगा"}</th>
                <th className='text-center'>{language === "English" ? "Girl" : "मुलगी"}</th>
                <th></th>
              </tr>
            </thead>
            <style jsx>
                  {`
                  /* Full screen overlay to show loading with background blur */
                    .loading-overlay {
                      position: fixed;
                      top: 0;
                      right: 0;
                      width: 88.5%;
                      height: 100%;
                      background: rgba(146, 146, 146, 0.1); /* Semi-transparent background */
                      backdrop-filter: blur(1px); /* Apply blur effect to the background */
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      z-index: 9999; /* Ensure it appears on top */
                    }

                    /* Style for the loading spinner or image */
                    .loading-overlay .text-center {
                      color: white;
                      font-size: 24px;
                      font-weight: bold;
                    }
                    th, td {
                      width:auto;
                    }

                  `}
            </style>
            <tbody>
              {loading ? (
                  <div className='loading-overlay'>
                    <div  className="text-center">
                      <img src={loadingimg} style={{width:'100px'}} alt="Loading..." /> 
                    </div>
                  </div>
               
              ) : (
                casteData.map((caste, index) => (
                  <tr key={index}>
                    <td>{caste.name}</td>
                    {classData.map(className => (
                      <React.Fragment key={className}>
                        <td>{getClassTotal(caste, className, 'male')}</td>
                        <td>{getClassTotal(caste, className, 'female')}</td>
                      </React.Fragment>
                    ))}
                    <td>
                      {Object.values(caste.classes).reduce((total, classCounts) => total + (classCounts.male || 0), 0)}
                    </td>
                    <td>
                      {Object.values(caste.classes).reduce((total, classCounts) => total + (classCounts.female || 0), 0)}
                    </td>
                    <td>
                      {Object.values(caste.classes).reduce((total, classCounts) => total + (classCounts.male || 0) + (classCounts.female || 0), 0)}
                    </td>
                  </tr>
                ))
              )}
              <tr>
                <td className='bg-secondary'>{language === "English" ? "Total" : "एकूण"}</td>
                {classData.map((className, index) => (
                  <React.Fragment key={index}>
                    <td className='bg-secondary'>{getClassTotalOverall(className, 'male')}</td>
                    <td className='bg-secondary'>{getClassTotalOverall(className, 'female')}</td>
                  </React.Fragment>
                ))}
                <td className='bg-secondary'>
                  {classData.reduce((total, className) => total + getClassTotalOverall(className, 'male'), 0)}
                </td>
                <td className='bg-secondary'>
                  {classData.reduce((total, className) => total + getClassTotalOverall(className, 'female'), 0)}
                </td>
                <td className='bg-secondary'>
                  {classData.reduce((total, className) => total + getClassTotalOverall(className, 'male') + getClassTotalOverall(className, 'female'), 0)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CasteWiseReport;